const SmileIcons = () => {
	return (
		<svg
			className="icons-gray"
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				fill="#33383F"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M7.01568 13.0836C7.52177 12.8625 8.11129 13.0935 8.33241 13.5996C8.95057 15.0144 10.3613 16 12 16C13.6387 16 15.0495 15.0144 15.6676 13.5996C15.8887 13.0935 16.4783 12.8625 16.9843 13.0836C17.4904 13.3048 17.7214 13.8943 17.5003 14.4004C16.5754 16.5174 14.4619 18 12 18C9.53807 18 7.42466 16.5174 6.4997 14.4004C6.27858 13.8943 6.5096 13.3048 7.01568 13.0836Z"
				fill="#33383F"
			/>
			<path
				d="M9 9C9 9.55228 8.55228 10 8 10C7.44772 10 7 9.55228 7 9C7 8.44772 7.44772 8 8 8C8.55228 8 9 8.44772 9 9Z"
				fill="#33383F"
			/>
			<path
				d="M17 9C17 9.55228 16.5523 10 16 10C15.4477 10 15 9.55228 15 9C15 8.44772 15.4477 8 16 8C16.5523 8 17 8.44772 17 9Z"
				fill="#33383F"
			/>
		</svg>
	);
};
export default SmileIcons;
